export default "__VITE_ASSET__CWw$fyM5__"